import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ClipboardTextFilledSvg = function ClipboardTextFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.676 2.249H8.324v3.678h7.352zM3.5 3.399h3.446v3.907h10.108V3.398H20.5V22.25h-17zm4.365 9.425h8.27v-1.84h-8.27zm8.27 4.597h-8.27v-1.839h8.27z",
    clipRule: "evenodd"
  }));
};
export var ClipboardTextFilled = function ClipboardTextFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ClipboardTextFilledSvg
  }));
};